module.exports = __webpack_public_path__ + "img/emphasis-back2.4a24fc8b.png";